module.exports = __webpack_public_path__ + "img/OHM.e58ed3e7.png";